const getDataAttr = (attr, element) => {
  if (attr in element.dataset) {
    return element.dataset[attr];
  }
  return '';
};
export default getDataAttr;